import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon66: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 18.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 18 20" width={width} height={height} {...props}>
      <Path
        d="M14.464 0C14.76 0 15 0.224 15 0.5V6.5C15 6.776 14.76 7 14.464 7C14.168 7 13.929 6.776 13.929 6.5V1H1.071V19H4.821C5.117 19 5.357 19.224 5.357 19.5C5.357 19.776 5.117 20 4.821 20H0.535698C0.239798 20 0 19.776 0 19.5V0.5C0 0.224 0.239798 0 0.535698 0H14.464ZM16.721 9.439L17.562 10.278C18.146 10.865 18.146 11.812 17.561 12.399L16.031 13.929L10.112 19.847C10.014 19.945 9.881 20 9.742 20H7.523C7.234 20 7 19.766 7 19.477V17.258C7 17.119 7.055 16.986 7.153 16.888L14.6 9.44C15.186 8.853 16.136 8.85299 16.721 9.439ZM15.341 10.18L13.812 11.708L8.046 17.474V18.954H9.526L15.292 13.189L16.821 11.66C16.998 11.482 16.998 11.195 16.822 11.018L15.981 10.179C15.804 10.002 15.518 10.002 15.341 10.18ZM7.5 10C7.776 10 8 10.224 8 10.5C8 10.776 7.776 11 7.5 11H3.5C3.224 11 3 10.776 3 10.5C3 10.224 3.224 10 3.5 10H7.5ZM10.5 7C10.776 7 11 7.224 11 7.5C11 7.776 10.776 8 10.5 8H3.5C3.224 8 3 7.776 3 7.5C3 7.224 3.224 7 3.5 7H10.5ZM10.5 4C10.776 4 11 4.224 11 4.5C11 4.776 10.776 5 10.5 5H3.5C3.224 5 3 4.776 3 4.5C3 4.224 3.224 4 3.5 4H10.5Z"
        fill="#404040"
      />
    </Icon>
  )
}
